import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as moment from 'moment/moment.js';

@Component({
  selector: 'app-gst-details',
  templateUrl: './gst-details.page.html',
  styleUrls: ['./gst-details.page.scss'],
})
export class GstDetailsPage implements OnInit {
  gstData;
  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() {
  }

  
  formatDate(date) {
    return moment(date).format("ll");
  }

  dismissModal(e){
    this.modalController.dismiss(e)
  }

}
